import LogoSvg from 'assets/images/logo-diamond.svg'
import I18n from 'components/I18n'
import messages from 'lang'
import React from 'react'

import { Wrapper } from '../../../styles'
import { Description, LogoWrapper, Title } from '../../styles'

const Pending = () => (
  <Wrapper>
    <LogoWrapper>
      <img alt='Blockchain logo' src={LogoSvg} />
    </LogoWrapper>
    <Title>
      <I18n data={messages.link_bank_pending_title} />
    </Title>
    <Description>
      <I18n data={messages.link_bank_pending_subtitle} />
    </Description>
  </Wrapper>
)

export default Pending
